import React, { Component } from 'react';
import {observer} from 'mobx-react'
import styles from '../index.css';
import FontAwesome from 'react-fontawesome';
import SimpleLineIcon from 'react-simple-line-icons';
// import samplePic from './sample_pic.jpg';

@observer
export default class DropItem extends Component {
  state = {open:false,inputValue:this.props.quantity};
  render() {
    return (
      <div className={styles.equipItem + ((this.state.open) ? (' ' + styles.openDropdown) : '')}>
        <div className={styles.equipRow}>
          <div className={styles.columnEquipName} onClick={()=>{this.setState({open:!this.state.open})}}>{this.props.name}
            <div className={styles.dropdownArrow}>
              <FontAwesome name='chevron-down' />
            </div>
          </div>
          <div className={styles.columnCrops}>
            <div>{this.props.capacity ? this.props.capacity * 0.96 : (this.props.wheatpercents.min + "-" + this.props.wheatpercents.max + '\n' + this.props.wheateff.min + "-" + this.props.wheateff.max)}</div>
            <div>{this.props.capacity ? this.props.capacity * 0.8 : (this.props.rapepercents.min + "-" + this.props.rapepercents.max + '\n' + this.props.rapeeff.min + "-" + this.props.rapeeff.max)}</div>
            <div>{this.props.capacity ? this.props.capacity * 0.86 : (this.props.soypercents.min + "-"+ this.props.soypercents.max + '\n' + this.props.soyeff.min + "-" + this.props.soyeff.max)}</div>
            <div>{this.props.capacity ? this.props.capacity * 0.52 : (this.props.sunflowerpercents.min + "-" + this.props.sunflowerpercents.max + '\n' + this.props.sunflowereff.min + "-" + this.props.sunflowereff.max)}</div>
            <div>{this.props.capacity ? this.props.capacity * 0.88 : (this.props.cornpercents.min + "-" + this.props.cornpercents.max + '\n' + this.props.corneff.min + "-" + this.props.corneff.max)}</div>
          </div>
          <div className={styles.columnPrice}>{this.props.price}</div>
          <div className={styles.columnQuantity}>
            <div className={styles.quantityDecrease}
                 onClick={()=>{if(+this.props.quantity-1 >= 0){this.setState({inputValue:+this.state.inputValue-1});this.props.func(-1);}}}>
              <SimpleLineIcon name="arrow-left"  style={{fontSize: '1.25rem'}} />
            </div>
            <input className={styles.itemQuantity} value={this.props.quantity}
            onChange={(e)=>{if(!(/\D+/g.test(e.target.value))){this.props.func(+e.target.value - this.props.quantity)}}}
            />
            <div className={styles.quantityIncrease}
                 onClick={()=>{this.setState({inputValue:+this.state.inputValue+1});this.props.func(1);}}>
              <SimpleLineIcon name="arrow-right"  style={{fontSize: '1.25rem'}} />
            </div>
          </div>
        </div>
        <div className={styles.dropdown}>
          <div>
            <h4>{this.props.name}</h4>
            <p>{this.props.definition}</p>
          </div>
          <div className={styles.dropdownPic}><img src={this.props.picture} alt="" /></div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/shared/components/EquipComponents/DropItem/index.js